package com.essntl.features.authentication.ui.auth

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.authentication.domain.models.CheckModel
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.toastmanager.ToastManager
import com.essntl.uikit.currentPlatform
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class AuthViewModel(
    private val authRepository: AuthRepository,
    private val toastManager: ToastManager,
    private val state: MutableStateFlow<AuthState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AuthEvent) {
        when (event) {
            is AuthEvent.UpdateAuthFields -> updateAuthFields(event)

            is AuthEvent.CheckEmail -> checkEmail()
            is AuthEvent.UpdateEmailError -> updateEmailError()

            is AuthEvent.Register -> register()
            is AuthEvent.ClearRegister -> clearRegister()

            is AuthEvent.Login -> login()
            is AuthEvent.Clear -> clear()

            is AuthEvent.Back -> back()

        }
    }

    private fun updateAuthFields(event: AuthEvent.UpdateAuthFields) {
        state.value = event.state.copy(emailError = "")
    }

    private fun checkEmail() =
        scope.launch {
            loadingManager.emitLoading(true)

            state.update {
                it.copy(
                    checkSubmit = State.loading(),
                )
            }

            authRepository
                .checkEmail(state.value.email)
                .onSuccess { model ->
                    state.update {
                        it.copy(
                            checkSubmit = if (currentPlatform.isMobile)
                                if (model.state == CheckModel.State.USER_NOT_FOUND)
                                    State.success(CheckModel(state = CheckModel.State.NO_TENANT_FOUND))
                                else
                                    State.success(data = model)
                            else
                                State.success(data = model),
                        )
                    }
                }.onFailure {
                    state.update {
                        it.copy(
                            checkSubmit = State.failure(),
                        )
                    }
                }
        }.invokeOnCompletion {
            scope.launch {
                loadingManager.emitLoading(false)
            }
        }

    private fun updateEmailError() {
        state.value = state.value.copy(
            emailError = if (currentPlatform.isMobile)
                "This email is not recognized. Please create an account using the desktop app." else
                "The email is not registered. Please contact your admin.",
        )
    }

    private fun register() =
        getData(
            getData = {
                authRepository.register(
                    state.value.email,
                    state.value.firstName,
                    state.value.lastName,
                )
            },
            getState = { state.value.registerSubmit },
            setState = { newState -> state.update { it.copy(registerSubmit = newState) } },
        )

    private fun clearRegister() =
        state.update {
            it.copy(
                firstName = "",
                lastName = "",
                registerSubmit = State(),
                checkSubmit = State.success(CheckModel(state = CheckModel.State.OTP_SENT)),
            )
        }

    private fun login() =
        getData(
            getData = {
                authRepository.verifyEmailOtp(
                    essentialEmail = state.value.email,
                    token = state.value.otp,
                )
            },
            getState = { state.value.loginSubmit },
            setState = { newState -> state.update { it.copy(loginSubmit = newState) } },
        )


    private fun clear() {
        state.value = AuthState()
    }

    private fun back() =
        state.update {
            it.copy(
                checkSubmit = State.success(CheckModel(state = CheckModel.State.NO_TENANT_FOUND)),
            )
        }
}